module.exports = __webpack_public_path__ + "static/NotoSerif-BoldItalic-50c247fa59123af1bab1f7dc0977fdd4.woff";